import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { TranslocoService } from '@jsverse/transloco';
import { JuanaProduct } from '../../../core/models/juana/juana.types';
import { LanguageService } from '../../../core/services/language.service';

@Component({
  selector: 'app-juana-product-card',
  standalone: false,
  templateUrl: './juana-product-card.component.html',
  styleUrl: './juana-product-card.component.scss',
})
export class JuanaProductCardComponent {
  @Input() products: JuanaProduct[] = [];

  constructor(
    private router: Router,
    private transloco: TranslocoService,
    private languageService: LanguageService,
  ) {}

  fmt(n: number | null): string {
    if (!n || n <= 0) return this.transloco.translate('repuestos.productCard.noOffer');
    // Formato de miles según el idioma activo (es-CO usa puntos; en-US, comas).
    return '$' + Math.round(n).toLocaleString(this.languageService.locale);
  }

  open(p: JuanaProduct) {
    if (p.stock === 'out') return;
    this.router.navigate(['/dashboard/repuestos/configurar', p.id]);
  }
}
